export default __webpack_public_path__ + "static/media/004-dress.2e8efbc4.svg";